import React from "react";
import styles from "./Card.module.scss";
import classNames from "classnames";
import { useNavigate, useParams } from "react-router-dom";
import SecondaryButton from "../Button/SecondaryButton";
import ArrowIcon from "../../icons/right-arrow.svg";
import DefineIcon from "../../icons/define.svg";
import MeasureIcon from "../../icons/measure.svg";
import AnalyseIcon from "../../icons/analyse.svg";
import ImproveIcon from "../../icons/improve.svg";
import ControlIcon from "../../icons/control.svg";
import { useTranslation } from "react-i18next";

const Card = ({ className, category, modules, label }) => {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getCategoryColorClassName = (category) => {
    switch (category) {
      case "define":
        return styles.borderDefine;
      case "analyse":
        return styles.borderAnalyse;
      case "measure":
        return styles.borderMeasure;
      case "improve":
        return styles.borderImprove;
      case "control":
        return styles.borderControl;
      default:
        return "";
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case "define":
        return DefineIcon;
      case "measure":
        return MeasureIcon;
      case "analyse":
        return AnalyseIcon;
      case "improve":
        return ImproveIcon;
      case "control":
        return ControlIcon;
      default:
        return null;
    }
  };


  const translateModuleTitle = (title, t) => {
    const key = title.replace(/\s+/g, "").toLowerCase(); // e.g. "Quality Management System"
    return t(`modules.${key}`, title); // fallback to original
  };

  return (
    <div
      className={classNames(
        styles.card,
        getCategoryColorClassName(category),
        className,
      )}
    >
      <div className={styles.categoryText}>
        {label || category}
        {getCategoryIcon(category) && (
          <img
            src={getCategoryIcon(category)}
            alt={`${label || category} icon`}
            className={styles.categoryIcon}
          />
        )}
      </div>
      <div className={styles.content}>
        {modules.map((module, index) => (
          <SecondaryButton
            key={index}
            text={translateModuleTitle(module.title, t)} onClick={() => navigate(`/${orgId}${module.path}`)}
            className={styles.moduleItem}
            iconPosition="right"
            icon={ArrowIcon}
          />
        ))}
      </div>
    </div>
  );
};

export default Card;
